import { render, staticRenderFns } from "./CommonLoadingView.vue?vue&type=template&id=3b1f5886&scoped=true&"
import script from "./CommonLoadingView.vue?vue&type=script&lang=js&"
export * from "./CommonLoadingView.vue?vue&type=script&lang=js&"
import style0 from "./CommonLoadingView.vue?vue&type=style&index=0&id=3b1f5886&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1f5886",
  null
  
)

export default component.exports